import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import {
  EventEmitter,
  SimpleChange,
  Component,
  OnChanges,
  OnDestroy,
  Output,
  Input,
} from "@angular/core";

// Environments
import { environment } from "src/environments/environment";

// Services
import { GamePlayService } from "src/app/modules/game-groups/services/game-play.service";
import { TranslationService } from "src/app/modules/shared/services/translation.service";
import { UserDetailsService } from "src/app/modules/user/services/user-details.service";
import { UtilityService } from "src/app/utility/utility.service";

@Component({
  selector: "app-free-spin-reward-card",
  templateUrl: "./free-spin-reward-card.component.html",
  styleUrls: ["./free-spin-reward-card.component.scss"],
})
export class FreeSpinRewardCardComponent implements OnChanges, OnDestroy {
  @Input() bonusDetails;
  @Input() callingFrom;
  @Output() callOpenRewardTCPopUp: EventEmitter<any> = new EventEmitter();
  mediaUrlPath: string = environment.mediaUrlPath;
  gamesUrlPath: string = environment.gamesUrlPath;
  bonusType: string;
  langCodeSub: Subscription;
  langCode: string;
  currencySymbolSubscription: any;
  currencySymbol: string;
  imgixParams: string;

  constructor(
    private utility: UtilityService,
    private gamePlayService: GamePlayService,
    private router: Router,
    private translationService: TranslationService,
    private userDetailsService: UserDetailsService
  ) {
    this.langCodeSub = this.translationService.langCodeSb$.subscribe(
      (langcode) => {
        this.langCode = langcode;
      }
    );
    this.currencySymbolSubscription = this.userDetailsService.currencySymbolSb$.subscribe(
      (curSymbol) => {
        this.currencySymbol = curSymbol;
      }
    );

    this.imgixParams = this.utility.getImgixParams();
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    if (changes["bonusDetails"]) {
      this.bonusDetails = changes["bonusDetails"].currentValue;
      this.bonusType = this.bonusDetails["bonusTypeFD"];
    }
    if (changes["callingFrom"]) {
      this.callingFrom = changes["callingFrom"].currentValue;
    }
  }

  launchGame(gameName) {
    gameName = this.utility.convertGameNameToUrl(gameName);
    let currentGameSlug = window.location.pathname.split("/");
    if (currentGameSlug[currentGameSlug.length - 1] != gameName) {
      this.gamePlayService.clearGameWindowData();
    }
    this.gamePlayService.setGameCalledfrom("realgame");
    let currentPath = window.location.pathname;
    setTimeout(() => {
      if (
        currentPath.includes(
          this.translationService.instant("url.game") + "/" + gameName
        )
      ) {
        this.gamePlayService.broadCastRelanuchGame(true);
      } else {
        this.router.navigate([
          this.langCode +
            "/" +
            this.translationService.instant("url.game") +
            "/" +
            gameName,
        ]);
      }
      this.utility.closeAccountComponent();
    });
  }

  openRewardTCPopUp(event) {
    this.callOpenRewardTCPopUp.emit(event);
  }

  ngOnDestroy() {
    this.langCodeSub.unsubscribe();
    this.currencySymbolSubscription.unsubscribe();
  }
}
